"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UIPopoverHeader = _interopRequireDefault(require("UIComponents/tooltip/UIPopoverHeader"));

var _UIPopoverBody = _interopRequireDefault(require("UIComponents/tooltip/UIPopoverBody"));

var _UIPopoverCloseButton = _interopRequireDefault(require("UIComponents/tooltip/UIPopoverCloseButton"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var _userSettings = require("ComposeUI/redux/actions/userSettings");

var i18nKey = function i18nKey(suffix) {
  return "ComposeUI.header.tabs.draftSunsetTooltip." + suffix;
};

var minimumTimeBetweenShowingPopover = 1000 * 60 * 60 * 24 * 10; // Milliseconds in 10 days

var DRAFT_SUNSET_POPOVER = 'draft-sunset-popover';
var StyledPopover = (0, _styledComponents.default)(_UIPopover.default).withConfig({
  displayName: "DraftSunsetPopover__StyledPopover",
  componentId: "s6b1i8-0"
})(["& .", "{padding:0 !important;}& .uiPopoverArrow{background-color:", ";}"], DRAFT_SUNSET_POPOVER, _colors.NORMAN);
var SunsetHeader = (0, _styledComponents.default)(_UIPopoverHeader.default).withConfig({
  displayName: "DraftSunsetPopover__SunsetHeader",
  componentId: "s6b1i8-1"
})(["padding:16px 24px;background-color:", ";color:", ";line-height:1.4;"], _colors.NORMAN, _colors.OLAF);
var SunsetBody = (0, _styledComponents.default)(_UIPopoverBody.default).withConfig({
  displayName: "DraftSunsetPopover__SunsetBody",
  componentId: "s6b1i8-2"
})(["padding:16px 24px;"]);

var getInitialPopoverOpen = function getInitialPopoverOpen(_ref) {
  var _ref$seenDraftSunset = _ref.seenDraftSunset,
      seenDraftSunset = _ref$seenDraftSunset === void 0 ? 0 : _ref$seenDraftSunset;
  return Date.now() - seenDraftSunset > minimumTimeBetweenShowingPopover;
};

function DraftSunsetPopover(props) {
  var renderedTab = props.renderedTab,
      userId = props.userId,
      userSettings = props.userSettings;

  var _useState = (0, _react.useState)(getInitialPopoverOpen(userSettings)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onClose = (0, _react.useCallback)(function () {
    setOpen(false);
    (0, _userSettings.markSeenDraftSunset)(userId, userSettings, Date.now());
  }, [userId, userSettings]);
  return _react.default.createElement(StyledPopover, {
    placement: "bottom",
    width: 300,
    open: open,
    innerClassName: DRAFT_SUNSET_POPOVER,
    content: _react.default.createElement("div", null, _react.default.createElement(SunsetHeader, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: i18nKey('headingText')
    })), _react.default.createElement(_UIPopoverCloseButton.default, {
      popoverUse: "shepherd",
      onClick: onClose
    })), _react.default.createElement(SunsetBody, null, _react.default.createElement(_FormattedMessage.default, {
      message: i18nKey('title')
    })))
  }, renderedTab);
}

DraftSunsetPopover.propTypes = {
  renderedTab: _propTypes.default.instanceOf(_UITab.default).isRequired,
  userId: _propTypes.default.number,
  userSettings: _propTypes.default.instanceOf(_UserSettings.default).isRequired
};
var _default = DraftSunsetPopover;
exports.default = _default;
module.exports = exports.default;